{
  "name": "@vestigas/customer-portal",
  "version": "1.8.15",
  "private": true,
  "description": "Web portal for Vestigas customers to manage their delivery notes, invoices, masterdata, and settings.",
  "type": "module",
  "scripts": {
    "build:beta": "env-cmd -e beta vite build",
    "build:dev": "env-cmd -e dev vite build",
    "build:dynamic": "env-cmd -e $BUILD_ENV vite build",
    "build:staging": "env-cmd -e staging vite build",
    "build": "env-cmd -e production vite build",
    "build:custom-dev": "vite build --mode development",
    "commits": "bash ../../summarize_commit_messages.sh",
    "generate-release-status": "node scripts/generate-release-status.mjs",
    "dev:local-custom": "VITE_DEV_ENV=local-backend env-cmd -e local-backend env-cmd -f .env.local --silent vite",
    "dev": "VITE_DEV_ENV=${env} env-cmd -e ${env:-dev} vite",
    "dev:mocked": "VITE_MOCK_ENDPOINTS=true pnpm dev",
    "i18n": "pnpm i18n:extract && pnpm i18n:sync",
    "i18n:extract": "i18next-cli extract",
    "i18n:sync": "i18next-cli sync && i18next-cli types",
    "i18n:lint": "i18next-cli lint",
    "format": "oxfmt --config ../../.oxfmtrc.json",
    "lint": "pnpm format && oxlint --fix --type-aware src",
    "preview": "vite preview",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org vestigas --project web-customer-portal ./build/ && sentry-cli sourcemaps upload --org vestigas --project web-customer-portal ./build/",
    "test:e2e:ui": "playwright test --ui",
    "test:e2e": "playwright test",
    "test": "vitest --config ./vite.config.ts"
  },
  "dependencies": {
    "@amplitude/analytics-browser": "catalog:",
    "@emotion/react": "catalog:",
    "@emotion/styled": "catalog:",
    "@formkit/auto-animate": "catalog:",
    "@hello-pangea/dnd": "^17.0.0",
    "@mui/material": "catalog:",
    "@mui/system": "catalog:",
    "@mui/x-data-grid": "catalog:",
    "@mui/x-data-grid-premium": "catalog:",
    "@mui/x-data-grid-pro": "catalog:",
    "@mui/x-date-pickers": "catalog:",
    "@mui/x-date-pickers-pro": "catalog:",
    "@mui/x-license": "catalog:",
    "@plugin-web-update-notification/vite": "catalog:",
    "@reduxjs/toolkit": "catalog:",
    "@sentry/react": "catalog:",
    "@tanem/react-nprogress": "catalog:",
    "@tanstack/devtools-vite": "catalog:",
    "@tanstack/react-devtools": "catalog:",
    "@tanstack/react-form": "catalog:",
    "@tanstack/react-form-devtools": "catalog:",
    "@tanstack/react-query": "catalog:",
    "@tanstack/react-query-devtools": "catalog:",
    "@tanstack/react-router": "catalog:",
    "@tanstack/react-router-devtools": "catalog:",
    "@tanstack/react-virtual": "catalog:",
    "@uidotdev/usehooks": "catalog:",
    "@vestigas/auth": "workspace:*",
    "@vestigas/data": "workspace:*",
    "@vestigas/logger": "workspace:*",
    "@vestigas/ui": "workspace:*",
    "@vestigas/utils": "workspace:*",
    "@xstate/react": "catalog:",
    "@xstate/store": "catalog:",
    "@xstate/store-react": "catalog:",
    "axios": "catalog:",
    "axios-auth-refresh": "^3.3.6",
    "canvas-confetti": "catalog:",
    "chart.js": "catalog:",
    "chartjs-adapter-dayjs-4": "catalog:",
    "chartjs-plugin-datalabels": "catalog:",
    "chartjs-plugin-stacked100": "^1.7.0",
    "cn": "catalog:",
    "dayjs": "catalog:",
    "emojibase": "catalog:",
    "env-cmd": "catalog:",
    "file-saver": "catalog:",
    "geo-coordinates-parser": "^1.7.4",
    "i18next": "catalog:",
    "json-beautify": "catalog:",
    "ky": "catalog:",
    "lodash-es": "catalog:",
    "modern-screenshot": "catalog:",
    "ms": "catalog:",
    "mutative": "catalog:",
    "oidc-react": "catalog:",
    "p-map": "catalog:",
    "pdf-merger-js": "^5.1.2",
    "react": "18.3.1",
    "react-chartjs-2": "catalog:",
    "react-dom": "18.3.1",
    "react-hot-toast": "catalog:",
    "react-hotkeys-hook": "catalog:",
    "react-i18next": "catalog:",
    "react-image-crop": "catalog:",
    "react-json-view-lite": "catalog:",
    "react-markdown": "catalog:",
    "react-pdf": "catalog:",
    "react-redux": "catalog:",
    "react-select": "catalog:",
    "react-select-async-paginate": "catalog:",
    "react-step-wizard": "^5.3.11",
    "redux": "catalog:",
    "remark-gfm": "catalog:",
    "snakecase-keys": "catalog:",
    "tailwindcss": "catalog:",
    "urlcat": "catalog:",
    "uuid": "catalog:",
    "workbox-window": "catalog:",
    "xlsx": "catalog:",
    "xstate": "catalog:",
    "zod": "catalog:"
  },
  "devDependencies": {
    "@playwright/test": "catalog:",
    "@sentry/vite-plugin": "catalog:",
    "@tailwindcss/vite": "catalog:",
    "@tanstack/router-plugin": "catalog:",
    "@testing-library/react": "catalog:",
    "@thednp/dommatrix": "catalog:",
    "@types/canvas-confetti": "catalog:",
    "@types/react": "catalog:",
    "@types/react-dom": "catalog:",
    "@vitejs/plugin-react": "catalog:",
    "@vitest/browser-playwright": "catalog:",
    "@vitest/coverage-istanbul": "catalog:",
    "dotenv": "17.4.2",
    "i18next-cli": "catalog:",
    "jsdom": "catalog:",
    "msw": "catalog:",
    "oxfmt": "catalog:",
    "unist-util-visit": "catalog:",
    "vite": "catalog:",
    "vite-plugin-compression2": "catalog:",
    "vite-plugin-i18next-loader": "catalog:",
    "vite-plugin-istanbul": "catalog:",
    "vite-plugin-pwa": "catalog:",
    "vite-plugin-svgr": "catalog:",
    "vite-plugin-webfont-dl": "catalog:",
    "vitest": "catalog:",
    "vitest-browser-react": "catalog:",
    "zocker": "catalog:"
  },
  "msw": {
    "workerDirectory": [
      "public"
    ]
  }
}
